<template>
<div>
    <nav class="side-menu">
        <ul>
            <li class="mobile-ico">
                <span @click="$store.state.show_menus = !$store.state.show_menus">☰</span>
            </li>
            <li class="search-ico"><span @click="openSearch">⌕</span></li>
            <!-- <li class="ticket-ico"><a :href="$store.state.ticket_link" target="_black">⍞</a></li> -->
            <li class="cart-ico" v-if="cart_count !== 0">
                <span @click="openCart">
                    ☑
                    <i v-if="cart_count">{{cart_count}}</i>
                </span>
            </li>
        </ul>
    </nav>
    <ul class="color-text">
        <li class="color-ico">
            <i @click="changeStyle('color')">◐</i>
        </li>
        <li class="text-ico">
            <i @click="changeStyle('text')">Ⓣ</i>
        </li>
    </ul>
    <nav class="mobile-navi" v-if="$store.state.menus && $store.state.show_menus">
        <div class="item">
            <h3>
                <Link :post_link="'/'">Home</Link>
            </h3>
        </div>
        <div class="item" v-for="(item, index) in $store.state.menus" :key="'menu-' + index">
            <h3 @click="openSubMenu(index, !item.show_sub_menu)">
                <span v-html="item.menu.title.title"></span>
            </h3>
            <ul ref="sub_menu">
                <li v-if="index !== 0"><Link :link="item.menu.title" v-html="item.menu.title.title"></Link></li>
                <li v-for="(sub_item, index) in item.menu.items" :key="index">
                    <Link :link="sub_item.link">
                        <span v-html="sub_item.link.title"></span>
                    </Link>
                </li>
            </ul>
        </div>
        <div class="search-item" @click="openSearch">⌕</div>
    </nav>

</div>
</template>

<script>
// import '@/assets/svg/color.svg?sprite';
// import '@/assets/svg/size.svg?sprite';
// import '@/assets/svg/search.svg?sprite';
// import '@/assets/svg/cart.svg?sprite';
// import '@/assets/svg/ticket.svg?sprite';
import { EventBus } from '@/events/bus.js';
import Link from '@/components/ui/Link.vue';

export default {
    name: 'side-menu',

    data() {
        return {
            cart_count: 0,
        }
    },
    components: {
        Link,
    },
    methods: {
        openSubMenu(index, is_open) {
            this.$store.state.menus[index].show_sub_menu = is_open;

            if (is_open) {
                this.$refs.sub_menu[index].style.display = 'block';
            } else {
                this.$refs.sub_menu[index].style.display = 'none';

            }
            // this.$store.commit('openSubMenu', {
            //     is_open: is_open,
            //     index: index,
            // });
        },
        openCart() {
            if (window.innerWidth < 787) {
                window.location.href = window.globals.home_url + '/cart/';
            } else {
                EventBus.$emit('cart.open');
            }

        },
        openSearch() {
            EventBus.$emit('search.open');
        },
        changeStyle(type) {
            let html = document.documentElement.classList;
            switch (type) {
                case 'color':
                    html.remove('large-size');
                    html.toggle('high-contrast');
                    break;
                case 'text':
                    html.remove('high-contrast');
                    html.toggle('large-size');
                    break;
            }
        },
    },

    mounted() {
        EventBus.$on('cart.update.count', (count = 0) => {
            this.cart_count = count;
        });
        EventBus.$on('get.menus', (menus = []) => {
            this.menus = menus;
            console.log(menus)
        });


    },
}
</script>

<style lang="scss">
    .mobile-navi {
        display: none;
        position: fixed;
        z-index: 10000;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: black;
        color: white;
        box-sizing: border-box;
        overflow: auto;
        padding: var(--padding);

        a, a:visited, a:active {
            color: white;
        }

        .item {
            // padding-bottom: var(--padding-50);

            h3 {
                font-size: var(--medium-size);
                padding: 0 0 1rem;
            }

            ul {
                display: none;
                padding: 0 0 5rem;
            }
        }

        .search-item {
            margin: var(--padding) 0 0;
            width: 55rem;
            position: relative;
            height: 8rem;
            font-size: var(--padding-x2);

            svg {
                height: 6rem;
                width: 6rem;
                fill: white;
                position: absolute;
                left: 0;
            }
        }
    }

    .side-menu {
        position: fixed;
        left: var(--padding-50);
        top: var(--padding-50);
        z-index: 10001;
        margin: .2rem 0 0;

        li {
            padding: var(--padding-25);
            display: inline-block;
        }

        .mobile-ico {
            display: none;
        }

        a,
        span {
            cursor: pointer;
            position: relative;
            display: block;
            font-size: var(--padding);

            i {
                position: absolute;
                font-size: var(--small-size);
                top: 70%;
                left: 110%;
            }

            svg {
                height: 100%;
                width: 100%;
                fill: black;
            }
        }
    }

    .color-text {
        position: fixed;
        left: 0;
        top: 50%;
        z-index: 999;
        border-right: 2px solid var(--font-color);
        border-top: 2px solid var(--font-color);
        border-bottom: 2px solid var(--font-color);
        background: white;
        margin-top: calc(var(--padding) * -1);

        li:first-child {
            border-bottom: 2px solid var(--font-color);
        }

        i {
            display: block;
            position: relative;
            width: calc(var(--padding) + 0.5rem);
            text-align: center;
            height: calc(var(--padding) + 0.5rem);
            line-height: calc(var(--padding) + 0.5rem);
            cursor: pointer;
        }
    }

    .high-contrast .color-text .color-ico i,
    .large-size .color-text .text-ico i {
        background: black;
        color: white;
    }

    body.type-stories,body.page-ideas,body.page-objects,body.type-ideas,body.body-class-ideas, body.type-peoples, body.page-single-people, body.page-single-stories, body.page-podcasts, body.page-single-podcast {
        .color-text {
            i {
                color: black;
                &:hover {
                    color: white;
                    background: black;
                }
            }
        }
    }

    body.page-home {
        .side-menu {
            a,
            span {
                color: white;

                svg {
                    fill: white;
                }
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .mobile-navi {
            display: block;
        }

        .side-menu {
            left: auto;
            top: var(--padding);
            right: var(--padding-50);
            margin: 0;

            li {
                display: block;
                padding: 0;

                a,
                span {
                    height: 10rem;
                    width: 10rem;
                    background: black;
                    border-radius: 50%;
                    color: white;
                    text-align: center;
                    line-height: 10rem;
                    position: relative;
                    font-size: calc(var(--padding) + 1rem);

                    i {
                        display: none;
                    }

                    svg {
                        height: 60%;
                        width: 60%;
                        fill: white;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                    }
                }

                &.mobile-ico {
                    display: block;
                }
            }



            .search-ico {
                display: none;
            }


            a,
            span {
                height: 5rem;
                width: 5rem;
            }
        }

        .color-text {
            position: fixed;
            left: auto;
            right: 0;
            margin-top: -3.6rem;
            border-width: 1px;
            border-left: 1px solid black;
            border-right: 0;

            li:first-child {
                border-width: 1px;
            }

            i {
                display: block;
                position: relative;
                width: 6rem;
                text-align: center;
                height: 7rem;
                line-height: 7rem;
                cursor: pointer;
            }
        }
    }
</style>
